import { LazyAction, LazyModule } from 'owa-bundling';

import './orchestrators/linkedCalendarSelectedOrchestrator';
import './orchestrators/refreshImmutableSelectedCalendarsOrchestrator';
import './mutators/setSelectedLinkedCalendarsCountMutator';

export { selectCalendar, selectCalendarWithId, pendingActions } from './actions/selectCalendar';
export { unselectCalendar } from './actions/unselectCalendar';
export {
    default as reloadCacheAndSelectCalendar,
    reloadCacheAndSelectCalendars,
} from './actions/reloadCacheAndSelectCalendar';
export { restoreSelectedCalendars } from './actions/restoreSelectedCalendars';
export { default as showSelectedCalendarOnly } from './utils/showSelectedCalendarOnly';

// a subset of this package is temporarily lazy until Calendar module surface views are moved behind lazy boundary
// instead of being a large chunk of Calendar module boot

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "SurfaceEventsNow" */ './lazyIndex')
);
export const lazyInitializeEventsNow = new LazyAction(lazyModule, m => m.initializeEventsNow);
